import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const publicClient = axios.create({ baseURL: API_BASE_URL });

export const getOrgBranding = async (slug) => {
  const response = await publicClient.get(`/api/v1/public/organizations/${slug}/branding`);
  return response.data;
};

// Resolve branding from the current host (domain-based login branding). The
// backend reads X-Forwarded-Host/Host and matches it against the registered
// domain allowlist, returning `data: null` for an unmapped host.
export const getOrgBrandingByHost = async () => {
  const response = await publicClient.get('/api/v1/public/organizations/by-host/branding');
  return response.data;
};
